import { Box, Stack, Text } from "@chakra-ui/react";
import { PhotoCapture, Title, TitleBar, useModalView } from "components";
import { IStatefulUI } from "interfaces";
import { useMemo, useState } from "react";
import { uploadFile } from "utils";
import { FormState } from ".";

import toLower from "lodash/toLower";
import { useCreateKycMutation } from "apis";

interface StepThreeProps extends IStatefulUI<FormState> {}

export function StepThree(props: StepThreeProps) {
  const { state } = props;

  const { onNext } = useModalView();

  const photoFilename = `photo_capture__${state?.lastName}__${state?.country}__${Date.now()}`;

  const [isLoading, setIsLoading] = useState(false);
  const [file, setFile] = useState<File | null>(null);

  const [createKyc] = useCreateKycMutation();

  const handleCapture = (capFile: File | null, recapture = false) => {
    setFile(capFile);
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (!state?.identitficationFile && !file) return;

    try {
      setIsLoading(true);
      const [photo, identity] = await Promise.all([
        uploadFile(file!, file?.name),
        uploadFile(state.identitficationFile!, `${toLower(state?.country)}___primaryid___${Date.now()}`),
      ]);

      if (!!photo && !!identity) {
        const dto = getDto(state as FormState, photo.location, identity.location);
        const result = await createKyc(dto).unwrap();

        if (!!result && result === "success") onNext();
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const isDisabled = useMemo(() => !state?.identitficationFile || !file || isLoading, [file, state, isLoading]);

  return (
    <Stack as="form" px="3px" pb="100px">
      <Box mb="34px !important">
        <TitleBar>
          <Title color="primary.default">Facial Capture</Title>
        </TitleBar>

        <Text fontSize="14px" fontWeight="500">
          Take a selfie photo of your face looking straight at the camera. Your face must be clearly visible. Please remove your
          glasses or head wear, if applicable
        </Text>
      </Box>

      {/* <VStack> */}
      <PhotoCapture filename={photoFilename} onCapture={handleCapture} _upload={{ isDisabled, onClick: handleSubmit, isLoading }} />
      {/* </VStack> */}

      {/* <VStack mt="40px !important">
        <Button w="100%">Next</Button>
      </VStack> */}
    </Stack>
  );
}

function getDto(state: FormState, selfie: string, identity: string) {
  const [year, month, day] = String(state?.dateOfBirth).split("-");

  return {
    kycSchema: "PersonalDataAndDocuments",
    docs: {
      selfieDocument: selfie,
      // documentName: "Testing Tester",
      document: identity,
      identificationDocument: identity,
      documentType: state?.documentType!,
      documentCategory: "primaryId",
      country: state?.nationality!,
      firstName: state?.firstName,
      lastName: state?.lastName,
      dateOfBirth: {
        day,
        month,
        year,
      },
      // phoneNumber: String(state?.phoneCode).concat(state?.phone),
      address: {
        address1: state?.address!,
        isoCountryCode: state?.nationality!,
        // isoRegionCode: "LG",
        city: state?.city,
      },
    },
  };
}
